export { buildEmailMetadataAttachment } from '../_internal/operators/buildEmailMetadataAttachment';
export { getFriendlyNameFromFallbackAccount } from '../_internal/operators/getFriendlyNameFromFallbackAccount';
export { buildMetadataFromJS } from '../_internal/operators/buildMetadataFromJS';
export { getEmailReplyRecipients } from '../_internal/operators/getEmailReplyRecipients';
export { buildEmailFromAddress } from '../_internal/operators/buildEmailFromAddress';